import { POSITION_EMPTY_VALIDATION, POSITION_ERROR, POSITION_ERROR_HIDE, POSITION_HIDE_EMPTY_VALIDATION, POSITION_REPORT, } from "@frameworks/web/redux/interfaces/Reports/iPositionReport";
const initState = {
    data: {
        PositionData: {
            PositionSummary: {
                date: "",
                time: "",
                totalPnL: null,
                totalPnLPercent: "",
                realizedPnL: null,
                realizedPnLPercent: "",
                unRealizedMTM: null,
                unRealizedMTMPercent: "",
                daysMTM: null,
                daysMTMPercent: "",
                totalPosition: "",
                openPosition: "",
                closedPosition: "",
            },
            PositionDetailsClosed: [],
            PositionDetailsOpen: [],
        },
        SearchData: "",
        FilterData: {
            simpleFilter: { name: "", filters: [] },
            assetFilter: { name: "", filters: [] },
        },
        SortData: [],
        IsSummarize: false,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    squareOffStatus: {
        error: null,
        isOpen: null,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
};
const positionReport = (state = initState, action) => {
    switch (action.type) {
        case POSITION_REPORT:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case POSITION_ERROR:
            return Object.assign(Object.assign({}, state), { [action.errorType]: action.payload.errorData });
        case POSITION_ERROR_HIDE:
            return Object.assign(Object.assign({}, state), { [action.errorType]: initState[action.errorType] });
        case POSITION_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case POSITION_HIDE_EMPTY_VALIDATION:
            return Object.assign(Object.assign({}, state), { emptyValidation: initState.emptyValidation });
        default:
            return Object.assign({}, state);
    }
};
export default positionReport;
